import { CardHeaderBody } from "./card-header-body";

export class CardHeader {
    cardHeaderTitle : string;
    cardHederData: CardHeaderBody[];
    

    constructor(cardHeaderTitle : string,cardHederData: CardHeaderBody[]){
        this.cardHeaderTitle = cardHeaderTitle,
        this.cardHederData = cardHederData
    }
}